import Nullable from '@/types/nullable';
import User from '@/types/user';
import React from 'react';
import { Redirect, RouteProps } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import { isDevDebugMode } from '@/utils/environment';

interface PrivateRouteProps extends RouteProps {
  component: any;
  user: Nullable<User>;
}

const DevelopmentRoute = (props: PrivateRouteProps) => {
  if (!isDevDebugMode()) {
    return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
  }

  return <PrivateRoute {...props} />;
};

export default DevelopmentRoute;
